// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-main[data-v-d4d9c6e6] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.el-main[data-v-d4d9c6e6]  .login {\n  display: inline-block;\n  border: solid 0.3rem #DFE3E1;\n  border-radius: 1rem;\n  padding: 2em 4em;\n}\nh1[data-v-d4d9c6e6] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}", ""]);
// Exports
module.exports = exports;
